import Cookies from "js-cookie";
import { updateCart } from "../services/cart.service";
export default (($) => {
    console.log('UNTUCKit : Module : HearAboutUs : loaded');
    const $hearAboutUs = $('.js-hear-about-us');
    const $select = $('.js-hear-about-us select');
    const $checkout = $('.js-checkout');
    const hasPurchased = function () {
        const hasPurchasedCookie = Cookies.get('untuckit_has_purchased'); // set via shopify webpixel
        const howDidYouHearAboutUsCookie = Cookies.get('how-did-you-hear-about-us');
        console.log('UNTUCKit : Module : HearAboutUs : hasPurchased : hasPurchasedCookie', hasPurchasedCookie);
        console.log('UNTUCKit : Module : HearAboutUs : hasPurchased : howDidYouHearAboutUsCookie', howDidYouHearAboutUsCookie);
        return ((hasPurchasedCookie !== undefined) || (howDidYouHearAboutUsCookie !== undefined));
    };
    // ## Params ## //
    // > arr : array of items to shuffle
    // ## Return ## //
    // returns a shuffled array of items
    // ## Context ## //
    // see Fisher-Yates Shuffling (https://www.wikiwand.com/en/Fisher%E2%80%93Yates_shuffle)
    const shuffle = function (arr) {
        let i, j, temp;
        for (i = arr.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            temp = arr[i];
            arr[i] = arr[j];
            arr[j] = temp;
        }
        return arr;
    };
    const randomizeDropdown = function () {
        console.log('UNTUCKit : Module : HearAboutUs : randomizeDropdown');
        const $optionsToShuffle = $('.js-inline-cart .js-hear-about-us [data-custom]');
        const $defaultOption = $('.js-inline-cart .js-hear-about-us [data-default]');
        const $otherOption = $('.js-inline-cart .js-hear-about-us [data-fixed]');
        const shuffled = shuffle($optionsToShuffle);
        $select.empty();
        $defaultOption.appendTo($select);
        for (let i = 0; i < shuffled.length; i++) {
            $(shuffled[i]).appendTo($select);
        }
        $otherOption.appendTo($select);
        $select.val('');
    };
    const bindUIActions = function () {
        console.log('UNTUCKit : Module : HearAboutUs : bindUIActions');
        $select.on('change', async function () {
            const $this = $(this), value = ($this.val() || '');
            Cookies.set('how-did-you-hear-about-us', value);
            await updateCart({ attributes: { "how-did-you-hear-about-us": value } });
        });
        $checkout.on('click', async function () {
            if ($hearAboutUs.length && $hearAboutUs.is(':visible') && !hasPurchased()) {
                await updateCart({ attributes: { "how-did-you-hear-about-us": Cookies.get('how-did-you-hear-about-us') || '' } });
            }
        });
    };
    function init() {
        const purchased = hasPurchased();
        console.log('UNTUCKit : Module : HearAboutUs : init');
        console.log('UNTUCKit : Module : HearAboutUs : hasPurchased', purchased);
        if (purchased) {
            $('body').addClass('hide-hear-about-us');
        }
        else {
            $hearAboutUs.show();
            randomizeDropdown();
            bindUIActions();
        }
    }
    return {
        init
    };
})($);
